import { StoreSelector } from 'mage-components';
import React from 'react';
import styled from 'styled-components';
import { useMidController } from '../controllers/MidController';
const MainContainer = styled.div.withConfig({ displayName: "MainContainer", componentId: "sc-1imxz0p" }) `
  margin: 16px 0 0 0;
  max-width: 250px;
`;
export default function MidSelector() {
    const { userMids, selectedMid, handleMidChange } = useMidController();
    return (React.createElement(MainContainer, null,
        React.createElement(StoreSelector, { borderless: true, mids: userMids, value: selectedMid, 
            // @ts-ignore: fix type of onChange
            onChange: handleMidChange })));
}
